import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { Headline } from 'components/Headline';

const Title = styled(Headline)`
  position: relative;

  margin-top: 1rem;
  margin-bottom: 2rem;
  margin-left: 2rem;
  padding-left: 1rem;

  &::after {
    content: '';

    position: absolute;
    top: 0rem;
    left: -2rem;

    display: block;

    height: 3.2rem;
    width: 1.6rem;

    background-color: ${pickColor('lightBlack')};
    border-radius: ${({ theme }) => theme.borderRadius.base};
  }
`;

export { Title };
